import React from 'react';
import Itinerary from './Itinerary';
import PassengersList from './PassengersList';
import { connect } from 'react-redux';

const GenericHeader = ({ useNewDesign }) => {
  if (useNewDesign) {
    return (
      <header
        className="gr-flex gr-items-center gr-justify-between gr-w-full gr-bg-white gr-border-b gr-border-gray-200 gr-px-4 gr-py-2 gr-gap-4 gr-relative"
        style={{ zIndex: 100 }}
      >
        <Itinerary />
        <PassengersList />
      </header>
    );
  }

  return (
    <header className="gr-flex gr-h-20 gr-w-full">
      <Itinerary />
      <PassengersList />
    </header>
  );
};

const Header = ({ useNewDesign }) => {
  return <GenericHeader useNewDesign={useNewDesign} />;
};

const mapStateToProps = (state) => ({
  activeWidget: state.session.activeWidget,
});

export default connect(mapStateToProps)(Header);
